import api from "../api";

export interface Rating {
  id: number;
  booking_id: number;
  rater_id: number;
  ratee_id: number;
  rating: number;
  comment?: string;
  created_at: string;
}

class RatingService {
  async getRatings(): Promise<Rating[]> {
    const response = await api.get("/ratings");
    return response.data.data;
  }

  async createRating(data: {
    booking_id: number;
    rated_id: number;
    rating: number;
    comment?: string;
    type: string;
  }): Promise<Rating> {
    const response = await api.post("/ratings", data);
    return response.data.data;
  }

  async canRateBooking(bookingId: number): Promise<{
    can_rate: boolean;
    reason?: string;
    type?: string;
    rated_id?: number;
    rated_name?: string;
    existing_rating?: {
      id: number;
      rating: number;
      comment?: string;
    };
  }> {
    const response = await api.get(`/ratings/booking/${bookingId}/can-rate`);
    return response.data;
  }
}

export default new RatingService();
